import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 8,
    border: `1px solid ${theme.palette.grey[200]}`
  },
  roomTypeRow: {
    display: 'grid',
    gridTemplateColumns: '5.42fr repeat(14,1fr)',
    height: 60,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default
  },

  rowName: {
    marginLeft: 8,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    color: theme.palette.grey[700],
    fontWeight: 600
  },

  rowNameContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: 4
  },
  time: {
    color: theme.palette.grey[500],
    fontSize: 12
  },
  requestName: {
    color: theme.palette.grey[500],
    marginLeft: 8,
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    fontSize: 14
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  dayContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    color: theme.palette.grey[800], // Default text color
    'box-sizing': 'border-box',
    borderLeft: `1px solid ${theme.palette.grey[300]}`, // Subtle border
    height: '100%',
    position: 'relative', // To position child elements absolutely
    padding: '8px 0' // Add vertical padding for better alignment
    // '&:hover': {
    //   backgroundColor: theme.palette.action.hover // Add hover effect
    // }
  },

  successBackground: {
    backgroundColor: '#DCF4EE', // Light green background for success
    color: `${theme.palette.secondary.main}!important` // Darker green text color
  },

  failedBackground: {
    backgroundColor: '#FDEAEF', // Light red background for failure
    color: `${theme.palette.primary.main}!important` // Darker red text color
  },

  numberOfRooms: {
    fontSize: 12,
    fontWeight: 'bold', // Ensure it's bold
    marginTop: 4
  },

  successText: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  totalSuccessBackground: {
    color: `${theme.palette.grey[600]}!important` // Darker green text color
  },

  totalFailedBackground: {
    color: `${theme.palette.primary.main}!important` // Darker red text color
  },

  totalNumberOfRooms: {
    fontSize: 20,
    marginTop: 4
  },

  totalSuccessText: {
    fontSize: 14,
    fontWeight: 'bold'
  },
  totalRoomTypeRow: {
    display: 'grid',
    gridTemplateColumns: '5.42fr repeat(14,1fr)',
    height: 60,
    alignItems: 'center',
    backgroundColor: theme.palette.background.paper
  },
  totalAllocateTitle: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.palette.grey[700],
    marginLeft: 8,
    flex: 1,
    display: 'flex',
    alignItems: 'center'
  },
  totalAllocationContainer: {
    display: 'flex',
    flexDirection: 'row'
  }
}))

export default useStyles
